import { useState } from 'react'
import ReactCardFlip from 'react-card-flip'
import './flipFingerContainer.style.less'
import fingerTipsIcon from '@/assets/images/icons/fingertips.svg'

interface props {
  frontComponent?: any
  backComponent?: any
}

function FlipFingerContainer(props: props) {
  const { frontComponent, backComponent } = props
  const [isFlipped, setIsFlipped] = useState(false)

  const handleClick = () => {
    setIsFlipped(!isFlipped)
  }

  return (
    <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
      <div>
        <div className="flip-container" onClick={handleClick}>
          <img
            className="finger-icon"
            src={fingerTipsIcon}
            height={99}
            width={99}
          />
        </div>
        {frontComponent}
      </div>

      <div>
        <div className="flip-container" onClick={handleClick}>
          <img
            className="finger-icon"
            src={fingerTipsIcon}
            height={99}
            width={99}
          />
        </div>
        {backComponent}
      </div>
    </ReactCardFlip>
  )
}

export default FlipFingerContainer
